'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountNav = function AccountNav(el) {
  (0, _classCallCheck3.default)(this, AccountNav);

  (0, _jquery2.default)('.acc-Nav_Link-pseudo').click(function (e) {
    e.preventDefault();
    var openContainer = (0, _jquery2.default)(this).data('pseudo');
    (0, _jquery2.default)('.acc-AccountFade').not(openContainer).fadeOut(function () {
      (0, _jquery2.default)(openContainer).fadeIn();
    });

    (0, _jquery2.default)('.acc-Nav_Link-pseudo').find('.acc-Nav_Icon').removeClass('acc-Nav_Icon-active');
    (0, _jquery2.default)(this).find('.acc-Nav_Icon').addClass('acc-Nav_Icon-active');
  });
};

exports.default = AccountNav;